<ul>
  <li><a href="/" >VoxPop Home</a></li>
  <div *ngIf="CanReview()" class="wrap">
    <li><a routerLink="/review/dashboard" routerLinkActive="active">Dashboard</a></li>
    <li><a routerLink="/review/topics" routerLinkActive="active">Topics</a></li>
    <li><a routerLink="/review/wires" routerLinkActive="active">Wires</a></li>
    <li><a routerLink="/review/programmes" routerLinkActive="active">Programmes</a></li>
  </div>
  <div *ngIf="CanAdminister()" class="wrap">
    <li><a routerLink="/review/profiles" routerLinkActive="active">Reviewers</a></li>
  </div>
  <div *ngIf="IsLoggedIn()">
    <li><a href="/auth/logout" id="logout">Logout</a></li>
  </div>
</ul>
